// Display-only estimates in major HKD units; never use this for a checkout quote.
export function formatReferencePrice(amount, rate, currency, currencyDisplay = 'symbol') {
    if (!Number.isFinite(amount) || !Number.isFinite(rate) || rate <= 0) return null;
    try {
        return new Intl.NumberFormat('en', { style: 'currency', currency, currencyDisplay }).format(amount * rate);
    } catch {
        return null;
    }
}
